export const INIT_APP_SUCCESS = 'INIT_APP_SUCCESS';